// extracted by mini-css-extract-plugin
module.exports = {"bottomNavigation":"styles_bottomNavigation__12tSY","item":"styles_item__Ud3qA","itemSelected":"styles_itemSelected__2Ym4r"};